function Cart_Yenir({ item }) {
  return <img src={item?.placeholderImage} className={` w-full `} />;
}

export default Cart_Yenir;
